
.variableSkuSettingsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
}

.variableSkuHeader {
  color: var(--static-text-strong);
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: 500;
}

.divider {
  width: 100%;
  height: 1px;
  background: var(--static-divider-standard);
  margin: 30px 0;
}

.space {
  width: 100%;
  height: 1px;
  margin-top: 20px;
}

.settingContainer {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
}

.settingLabelContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 15px 0 0;
  max-width: 19.5rem;
  min-width: 19.5rem;
}

.settingControlsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  padding: 1.25rem;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  width: 100%;
}

.settingLabelHeaderText {
  color: var(--static-text-strong);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
}

.settingLabelSubText {
  color: var(--static-text-weak);
  font-weight: 500;
  font-size: var(--fs-small);
  line-height: 20px;
}

.settingControlsLabel {
  color: var(--static-text-strong);
  font-weight: 500;
  font-size: var(--fs-small);
  margin-bottom: 10px;
}

.formulaPreviewDescriptionContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.formulaPreviewContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  padding: 1.25rem;
  width: 100%;
}

.formulaExampleContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.formulaExampleTextContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  margin-right: 10px;
}

.formulaPreviewText {
  color: var(--static-text-strong);
  font-size: 16px;
  text-transform: uppercase;
}

.formulaExampleText {
  color: var(--static-text-weak);
  font-size: var(--fs-small);
}

.formulaControlsContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.formulaVariablesContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  width: 100%;
}

.formulaControlsLabel {
  color: var(--static-text-strong);
  font-weight: 500;
  font-size: var(--fs-small);
}

.variableContainer {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  align-items: center;
  padding: 1.25rem;
  width: 100%;
}

.variableBorder {
  border-bottom: 1px solid var(--static-divider-standard);
}

.variableNumberContainer {
  color: var(--static-text-strong);
  font-weight: 500;
  font-size: var(--fs-small);
  text-wrap: nowrap;
}

.variableButtonsContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.trashButton {
  font-size: 24px;
}

.trashButton:hover {
  cursor: pointer;
}

.selectDropdownContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 10px;
}

.customInputError {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  color: var(--sentiment-text-negative);
}
